import { API_URL } from '../config/api';
import { DEMO_SIGNIN_DOMAIN } from '../config/auth';

// Compte de review des stores. Apple et Google exigent un compte utilisable par
// leurs equipes, or la connexion passe par un code a six chiffres recu par mail
// et un reviewer n'a acces a aucune boite. Le serveur detient donc une paire
// fixe (adresse + code) et l'echange contre un jeton de connexion GoTrue.
//
// Deux garde-fous :
//
//  - Le filtre de domaine est LOCAL. Seules les adresses du domaine de l'app
//    declenchent l'appel : le code d'un utilisateur ordinaire ne part jamais
//    ailleurs que chez Supabase. Le filtre ne demande rien au serveur, il ne
//    revele donc aucune adresse existante.
//  - L'echec est SILENCIEUX. Serveur absent, en panne, ou paire refusee : on
//    rend null et l'appelant continue son chemin Supabase normal. Une panne de
//    notre backend ne doit pas empecher une connexion ordinaire.

export function isDemoAddress(email) {
  return String(email || '')
    .trim()
    .toLowerCase()
    .endsWith(DEMO_SIGNIN_DOMAIN);
}

// Rend le token_hash a presenter a verifyOtp, ou null. Null ne dit pas si la
// paire etait mauvaise ou si le serveur n'a pas repondu : dans les deux cas
// l'appelant fait exactement la meme chose.
export async function requestDemoSignIn(email, code) {
  if (!isDemoAddress(email)) return null;
  try {
    const res = await fetch(`${API_URL}/api/auth/demo-signin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: String(email).trim(), code: String(code).trim() }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.ok === true && data.token_hash ? data.token_hash : null;
  } catch {
    return null;
  }
}
